import type {SocialAccount} from '@Components/social-media/account.vo';
import type {PlatformMediaType} from '@Components/social-media/post.vo';

export enum SocialProfileIconSize {
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export interface SocialProfileIconProps {
  size: SocialProfileIconSize;
  account: SocialAccount;
  onClick?: VoidFunction;
  className?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  showPlatformIcon?: boolean;
  showHoverOverlay?: boolean;
  onRemoveClick?: VoidFunction;
  isError?: boolean;
  platformMediaType?: PlatformMediaType;
}
